import React from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const ProfileManagementSkeleton = () => {
    return (
        // <div className="max-w-3xl mx-auto">
        <div className="max-w-2xl mt-1 min-h-screen">

            <Card>
                <CardHeader>
                    <Skeleton className="h-8 w-48 mb-2" /> {/* Profile Management title */}
                    <Skeleton className="h-4 w-3/4" /> {/* Description */}
                </CardHeader>
                <CardContent>
                    {/* Tabs List */}
                    <div className="flex gap-2 mb-6">
                        {['BasicDetails', 'Address', 'BankAccount'].map((tab) => (
                            <Skeleton key={tab} className="h-10 w-32 rounded-md" />
                        ))}
                    </div>

                    {/* Tab Content Area */}
                    <div className="space-y-6">
                        {/* Section Header */}
                        <div className="border-b pb-4 mb-6">
                            <Skeleton className="h-6 w-56 mb-2" /> {/* Section title */}
                            <Skeleton className="h-4 w-3/4" /> {/* Section description */}
                        </div>

                        {/* Form Fields - Basic Details */}
                        <div className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="space-y-2">
                                    <Skeleton className="h-5 w-24" />
                                    <Skeleton className="h-10 w-full" />
                                </div>
                                <div className="space-y-2">
                                    <Skeleton className="h-5 w-24" />
                                    <Skeleton className="h-10 w-full" />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <Skeleton className="h-5 w-16" />
                                <Skeleton className="h-10 w-full" />
                            </div>

                            <div className="space-y-2">
                                <Skeleton className="h-5 w-28" />
                                <Skeleton className="h-10 w-full" />
                            </div>

                            <div className="flex items-center space-x-2">
                                <Skeleton className="h-5 w-5 rounded-full" />
                                <Skeleton className="h-5 w-48" />
                            </div>

                            <div className="pt-4">
                                <Skeleton className="h-10 w-full rounded-md" />
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default ProfileManagementSkeleton;